import React from "react";
import Rodal from "rodal";

function Alert(props) {
	const {
			visible,
			options,
			title,
			description,
			closeAction,
			onClose,
			onAccept,
			cancelText,
			acceptText,
			closeOnCancel,
			customStyles,
			noTheme,
		} = props,
		onCancel = closeOnCancel ? closeAction : props.onCancel;

	return (
		<Rodal
			className="flex-rodal"
			visible={visible}
			onClose={() => {
				if (onClose) onClose();
				closeAction();
			}}
			customStyles={customStyles}
			{...options}
		>
			<div className={noTheme ? "" : "rodal-content"}>
				<div className={`${noTheme ? "" : "p-5"}`}>
					{title && <h2 className="text-black mb-3">{title}</h2>}
					{description && <div style={{ lineHeight: 1.5 }}>{description}</div>}
				</div>

				{((options && options.showCloseButton === false && !onCancel && !onAccept) ||
					(!onCancel && onAccept)) && (
					<div className="bg-gray-50 px-4 pb-4 flex gap-4 justify-end">
						<button
							className={`w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-1 text-base font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 sm:w-auto sm:text-sm bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500`}
							onClick={onAccept || onClose || closeAction}
						>
							{acceptText || "OK"}
						</button>
					</div>
				)}

				{onCancel && onAccept && (
					<div className="d-flex btn-clean-group">
						<button
							className={`btn-clean text-danger font-weight-medium p-3 divider-top w-100`}
							style={{ padding: "0.6rem 0 0.7rem 0 !important" }}
							onClick={() => {
								if (onClose) onClose();
								if (onCancel) onCancel();
							}}
						>
							{cancelText || "Close"}
						</button>

						<button
							className={`btn-clean text-primary font-weight-medium p-3 divider-top w-100`}
							style={{ padding: "0.6rem 0 0.7rem 0 !important" }}
							onClick={() => {
								if (onClose) onClose();
								if (onAccept) onAccept();
							}}
						>
							{acceptText || "OK"}
						</button>
					</div>
				)}
			</div>
			{noTheme && <style>{".rodal-close::before, .rodal-close::after { background: #fff; }"}</style>}
		</Rodal>
	);
}

export default Alert;
